<div class="rs-maxh rs-padding-bottom2">
  <span id="ac-download-anchor" aria-hidden="true" tabindex="-1"></span>
  <div
    class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh"
    id="ac-downloadPanel"
    role="region"
    aria-live="polite"
  >
    <div class="show-for-touch rs-maxh jsrs-download-view">
      <mprd-download-desktop
        *ngIf="selectedMobileView === ViewType.DESKTOP"
        (toggleView)="toggleMobileView()"
      ></mprd-download-desktop>
      <mprd-download-mobile
        *ngIf="selectedMobileView === ViewType.MOBILE"
        (toggleView)="toggleMobileView()"
      ></mprd-download-mobile>
    </div>
    <div class="hide-for-touch rs-maxh jsrs-download-view">
      <mprd-download-desktop
        *ngIf="selectedDesktopView === ViewType.DESKTOP"
        (toggleView)="toggleDesktopView()"
      ></mprd-download-desktop>
      <mprd-download-mobile
        *ngIf="selectedDesktopView === ViewType.MOBILE"
        (toggleView)="toggleDesktopView()"
      ></mprd-download-mobile>
    </div>
  </div>
</div>
